"use strict";
// tslint:disable
/**
 * Laravel WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferStateEnum = exports.OfferToJSON = exports.OfferFromJSONTyped = exports.OfferFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function OfferFromJSON(json) {
    return OfferFromJSONTyped(json, false);
}
exports.OfferFromJSON = OfferFromJSON;
function OfferFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': new Date(json['created_at']),
        'modifiedAt': new Date(json['modified_at']),
        'state': json['state'],
        'upvotedByUser': !runtime_1.exists(json, 'upvoted_by_user') ? undefined : json['upvoted_by_user'],
        'details': _1.OfferDetailsFromJSON(json['details']),
        'media': !runtime_1.exists(json, 'media') ? undefined : json['media'].map(_1.OfferMediaFromJSON),
        'owner': !runtime_1.exists(json, 'owner') ? undefined : _1.MemberFromJSON(json['owner']),
        'quotes': !runtime_1.exists(json, 'quotes') ? undefined : json['quotes'].map(_1.QuoteFromJSON),
        'trade': !runtime_1.exists(json, 'trade') ? undefined : _1.TradeFromJSON(json['trade']),
    };
}
exports.OfferFromJSONTyped = OfferFromJSONTyped;
function OfferToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'created_at': value.createdAt.toISOString(),
        'modified_at': value.modifiedAt.toISOString(),
        'state': value.state,
        'upvoted_by_user': value.upvotedByUser,
        'details': _1.OfferDetailsToJSON(value.details),
        'media': value.media == null ? undefined : value.media.map(_1.OfferMediaToJSON),
        'owner': _1.MemberToJSON(value.owner),
        'quotes': value.quotes == null ? undefined : value.quotes.map(_1.QuoteToJSON),
        'trade': _1.TradeToJSON(value.trade),
    };
}
exports.OfferToJSON = OfferToJSON;
/**
* @export
* @enum {string}
*/
var OfferStateEnum;
(function (OfferStateEnum) {
    OfferStateEnum["Draft"] = "draft";
    OfferStateEnum["Published"] = "published";
    OfferStateEnum["Reserved"] = "reserved";
    OfferStateEnum["Traded"] = "traded";
})(OfferStateEnum = exports.OfferStateEnum || (exports.OfferStateEnum = {}));
